<template>

  <div id="customer-history-payment">

    <vx-card ref="filterCard" title="Kunjungan Pasien" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Tgl Mulai</label>
          <datepicker name="start-date" v-model="startDate"></datepicker>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Tgl Akhir</label>
          <datepicker name="end-date" v-model="endDate"></datepicker>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-2/4 sm:w-1/2 w-full">&nbsp;</div>
        <div class="vx-col md:w-2/4 sm:w-1/2 w-full flex">
          <vs-button class="bg-primary w-full mr-2" icon-pack="feather" icon="icon-printer" @click="printPreview(1)">View</vs-button>
          <vs-button class="bg-warning w-full" icon-pack="feather" icon="icon-external-link" @click="exportExcel">Export Excel</vs-button>
        </div>
      </div>
      <!--div class="vx-row mt-2">
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">{{printByValph}}</label>
          <vs-input :placeholder="printByValph" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="printByVal" v-on:keyup.enter="searchReport" class="w-full mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-2/3 sm:w-1/2 w-full" v-if="printByFilter.value==='customer'">
          <label class="text-sm opacity-75">Name</label>
          <vs-select
            autocomplete
            class="w-2/3"
            name="patient"
            placeholder="Cari Pasien (No MR/Nama/Tgl Lahir/)"
            v-model="patient"
            @input-change="searchPatient"
            ref="patient"
            >
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in listPatient" />
          </vs-select>
        </div>
        <div class="vx-col md:w-2/3 sm:w-1/2 w-full" v-else="printByFilter.value==='customer'">
          <label class="text-sm opacity-75">Name</label>
          <vs-input disabled :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="valName" class="w-full mb-4 md:mb-0" />
        </div>
      </div>
      <div class="vx-row mt-2 flex" v-if="printByFilter.value==='customer'">
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Type</label>
          <vs-select
            autocomplete
            class="w-2/3"
            name="patient"
            placeholder="Cari Pasien (No MR/Nama/Tgl Lahir/)"
            v-model="patient"
            @input-change="searchPatient"
            ref="patient"
            >
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in listPatient" />
          </vs-select>
        </div>
      </div-->

      <vx-card title="Daftar Kunjungan" class="sticky-table-content">
        <vs-table
            stripe
            class="mb-base"
            noDataText="Tidak Ada Data"
            :data="listData"
            style="text-align:center;">
            <template slot="thead">
                <vs-th>No Laboratorium</vs-th>
                <vs-th>Kode Pemeriksaan</vs-th>
                <vs-th>Nama Pemeriksaan</vs-th>
                <vs-th>Hasil</vs-th>
                <vs-th>TAT</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"
                  :style="tr.id==idSelected?'background: rgba(var(--vs-primary),.1)!important;':''">
                    <vs-td>
                        {{data[indextr].noLab}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].code}}
                    </vs-td>
                    <vs-td>
                      {{data[indextr].name}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].result}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].tat}}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        {{mx}}
      </vx-card>      
    </vx-card>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
//import pdf from 'vue-pdf'
import report from '@/api/report.js';
import {baseURL} from "@/axios.js"

export default {
  components: {
    Datepicker
  },
  data () {
    return {
      startDate: new Date(),
      endDate: new Date().setDate(new Date().getDate() + 1),
      model:{},
      listData: [],
			perPage: 50,
			page: 1,      
      mx: '',
    }
  },
  methods: {
    async printPreview(pg) {
			this.model["perPage"] = this.perPage;
			this.model["page"] = pg;
			const frm = await report.reportPemeriksaanTatData(this.model);
			if (frm.data.status) {
				this.listData = frm.data.data;
        this.mx = "Jumlah Data " + this.listData.length;
			} else {
        this.listData= {maxPage:0, data: []};
      }
    },
  	async exportExcel() {
      let param = {};
      param.start_date = this.formatDate(this.startDate);
      param.end_date = this.formatDate(this.endDate);

  		/*this.$vs.loading(
  			{
  				type:'sound'
  			}
  		)*/

      let filename = "report-pemeriksaan-tat-"+this.formatDate1(this.startDate)+"-"+this.formatDate1(this.endDate)+".xlsx";
      let xmlHttpRequest = new XMLHttpRequest();
      xmlHttpRequest.onreadystatechange = function() {
          var a;
          if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {
              a = document.createElement('a');
              a.href = window.URL.createObjectURL(xmlHttpRequest.response);
              a.download = filename;
              a.style.display = 'none';
              document.body.appendChild(a);
              a.click();
          } else {
          }
      };

      let baseURL = "http://lisv2.healtri.com/rsdcwav2/api/";
      console.log(baseURL);
                //this.$vs.loading.close();
      xmlHttpRequest.open("GET", baseURL+report.rptExcelKunjungan(param), true);
      xmlHttpRequest.setRequestHeader("Content-Type", "application/json");
      xmlHttpRequest.responseType = 'blob';
      xmlHttpRequest.send();

  	/*	await report.rptExcelKunjungan(param)
  		.then(result => {
        let bytes = new Uint8Array(result.data.length);

        for (let i = 0; i < bytes.length; i++) {
            //bytes[i] = result.data.charCodeAt(i);
            bytes[i] = result.data[i];
        }
        const url = URL.createObjectURL(new Blob([bytes], {
  				type: 'application/vnd.excel'
  			}))

  			const link = document.createElement('a')
  			link.href = url
  			link.setAttribute('download', 'reportA.xlsx')
  			document.body.appendChild(link)
  			link.click()*/
/*
        var csvString = 'ı,ü,ü,ğ,ş,#Hashtag,ä,ö';
        var universalBOM = "\uFEFF";
        var a = window.document.createElement('a');
        a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+result.data));
        a.setAttribute('download', 'example.csv');
        window.document.body.appendChild(a);
        a.click();*/
  		/*})
  		.catch(error => {
  			if (error.response) {
  				this.$vs.notify({
  				  title: 'Information',
  				  time: 3000,
  				  text: error.response.data.message,
  				  iconPack: 'feather',
  				  icon: 'icon-alert-circle',
  				  color: 'danger',
  				  position: 'top-right'
  				});
  			}
  		});*/

  	},
    resetColFilters() {

    },
    searchPatient() {

    },
    async listKunjungan() {
        let param = {};
        param.startDate = '2020-11-20';
        param.endDate = '2020-11-21';

        //const frm = await report.listKunjungan(param);
    },
    formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
          month = '0' + month;
      if (day.length < 2)
          day = '0' + day;

      return [year, month, day].join('-');
    },
    formatDate1(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
          month = '0' + month;
      if (day.length < 2)
          day = '0' + day;

      return [year, month, day];
    }
  },
  created() {
  }
}
</script>
